import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performIssuePostRequest } from '@atlassian/jira-issue-reliability-fetch/src/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const notifyAttachmentViewed = (fileId: string): Promise<any> | undefined => {
	try {
		const url = '/rest/internal/3/analytics/attachment/viewed';
		return performIssuePostRequest(
			url,
			{
				body: JSON.stringify({ fileId }),
			},
			'attachments/issue-attachment-viewed-streamhub-events/src/services/attachment-viewed-event-notification',
		);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'notifyAttachmentViewed',
				packageName: 'jiraAttachmentViewedStreamhubEvents',
				teamName: 'gryffindor',
			},
		});
	}
};
